function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { getExpressionRanges, resolveCssVariablesInRecord } from '@deephaven/components';
import Log from '@deephaven/log';
import { ColorUtils } from '@deephaven/utils';
import chartThemeRaw from "./ChartTheme.module.css";
var log = Log.module('ChartTheme');
export function defaultChartTheme() {
  var _chartTheme$colorway;
  var chartTheme = resolveCssVariablesInRecord(chartThemeRaw);

  // The color normalization in `resolveCssVariablesInRecord` won't work for
  // colorway since it is an array of colors. We need to explicitly normalize
  // each color expression
  chartTheme.colorway = getExpressionRanges((_chartTheme$colorway = chartTheme.colorway) !== null && _chartTheme$colorway !== void 0 ? _chartTheme$colorway : '').map(_ref => {
    var _ref2 = _slicedToArray(_ref, 2),
      start = _ref2[0],
      end = _ref2[1];
    return ColorUtils.normalizeCssColor(chartTheme.colorway.substring(start, end + 1));
  }).join(' ');
  log.debug2('Chart theme:', chartThemeRaw);
  log.debug2('Chart theme derived:', chartTheme);
  return Object.freeze({
    paper_bgcolor: chartTheme['paper-bgcolor'],
    plot_bgcolor: chartTheme['plot-bgcolor'],
    title_color: chartTheme['title-color'],
    legend_color: chartTheme['legend-color'],
    colorway: chartTheme.colorway,
    gridcolor: chartTheme.gridcolor,
    linecolor: chartTheme.linecolor,
    zerolinecolor: chartTheme.zerolinecolor,
    error_band_line_color: chartTheme['error-band-line-color'],
    ohlc_increasing: chartTheme['ohlc-increasing'],
    ohlc_decreasing: chartTheme['ohlc-decreasing'],
    // Geo
    coastline_color: chartTheme['coastline-color'],
    land_color: chartTheme['land-color'],
    ocean_color: chartTheme['ocean-color'],
    lake_color: chartTheme['lake-color'],
    river_color: chartTheme['river-color'],
    // Indicator
    indicator_increasing: chartTheme['indicator-increasing'],
    indicator_decreasing: chartTheme['indicator-decreasing'],
    indicator_gauge: chartTheme['indicator-gauge'],
    // Map
    map_style: chartTheme['map-style']
  });
}
export default defaultChartTheme;
//# sourceMappingURL=ChartTheme.js.map